import { render } from "./WindowsTab.vue?vue&type=template&id=50551344&scoped=true&ts=true"
import script from "./WindowsTab.vue?vue&type=script&lang=ts"
export * from "./WindowsTab.vue?vue&type=script&lang=ts"

import "./WindowsTab.vue?vue&type=style&index=0&id=50551344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50551344"]])

export default __exports__